import store from './store';

export default store;



// WEBPACK FOOTER //
// ./src/app/tutorials/index.js